import { render, staticRenderFns } from "./RestoreAccount.vue?vue&type=template&id=894f988c&"
import script from "./RestoreAccount.vue?vue&type=script&lang=js&"
export * from "./RestoreAccount.vue?vue&type=script&lang=js&"
import style0 from "./RestoreAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports